import { camelToSnakeKeys } from '@convenia/helpers'
import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'
import { masker } from '@convenia/common-organisms/SystemFields/helpers/formatters'
import { mapFiles } from '@convenia/common-organisms/SystemFields/content/mappers/upload'
import { ADDRESSES_CONTACTS_AREA } from '@convenia/common-organisms/SystemFields/content/consts'

export const mapCep = (data = {}) => ({
  address: data?.street,
  district: data?.neighborhood,
  stateId: data?.state?.id,
  cityId: data?.city?.id,
})

export const mapAddress = (data = {}, params) => ({
  ...(data || {}),
  zipCode: masker('#####-###', data?.zipCode || ''),
  cityId: Number(data?.city?.id) || null,
  stateId: Number(data?.state?.id) || null,
  countryId: Number(data?.country?.id) || null,
  documentFiles: mapFiles(data?.documentFiles || [], params) || [],
})

export const mapAddressInput = ({ schema, data, invalidFields = [] } = {}) => {
  const {
    zipCode,
    address,
    number,
    complement,
    district,
    cityId,
    stateId,
    countryId,
    entityId,
  } = data || {}

  return {
    ...camelToSnakeKeys({
      ...(!invalidFields.includes('zipCode') ? { zipCode: (zipCode || '').replace(/\D+/, '') } : {}),
      ...(!invalidFields.includes('address') ? { address: address || '' } : {}),
      ...(!invalidFields.includes('number') ? { number } : {}),
      ...(!invalidFields.includes('complement') ? { complement: complement || '' } : {}),
      ...(!invalidFields.includes('district') ? { district: district || '' } : {}),
      ...(!invalidFields.includes('cityId') ? { cityId: cityId || null } : {}),
      ...(!invalidFields.includes('stateId') ? { stateId: stateId || null } : {}),
      ...(!invalidFields.includes('countryId') ? { countryId: countryId || null } : {}),
    }),
    custom_fields: mapCustomFieldValues({
      sectionId: ADDRESSES_CONTACTS_AREA.ADDRESS,
      entityId: entityId || undefined,
      data,
      schema,
    }),
  }
}
